export const ROOT_PATH = '/';
export const HOME_PATH = '/Home';
export const LOGIN_PATH = '/login';
export const BLOCKED_ACCOUNT_PATH = '/compte-bloque';
export const FIRST_CONNECTION_PATH = '/premiere-connexion';
export const CONSTITUTE_FOLDER_PATH = '/constituer-dossier';
export const TRACK_FOLDER_PATH = '/suivre-dossier';
export const MY_ADVISOR_PATH = '/mon-conseiller';
export const MY_PROFILE_PATH = '/mon-profil';
